// Пути иконок 24×24 (stroke) — общие для шторок и быстрых действий под ответом.
export const ICONS = {
  copy: 'M9 9h11v11H9zM5 15V5a2 2 0 0 1 2-2h10',
  draft: 'M17 3l4 4L8 20l-5 1 1-5z',
  'new-chat': 'M21 11a8 8 0 0 1-8 8H5l-2 2V11a8 8 0 0 1 8-8h2M18 2v6M15 5h6',
  repeat: 'M21 12a9 9 0 1 1-3-6.7M21 3v6h-6',
  archive: 'M3 5h18v4H3zM5 9v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9M10 13h4',
  export: 'M12 3v12M8 7l4-4 4 4M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7',
  trash: 'M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M6 6l1 14a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-14',
  rename: 'M17 3l4 4L8 20l-5 1 1-5z',
  settings: 'M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM12 2v3M12 19v3M4.2 4.2l2.2 2.2M17.6 17.6l2.2 2.2M2 12h3M19 12h3M4.2 19.8l2.2-2.2M17.6 6.4l2.2-2.2',
  camera: 'M4 8h3l2-3h6l2 3h3v11H4zM12 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7',
  list: 'M9 6h12M9 12h12M9 18h12M4 6l1 1 2-2M4 12l1 1 2-2M4 18l1 1 2-2',
  pin: 'M9 3h6l-1 6 4 3v2H6v-2l4-3-1-6zM12 14v7',
  print: 'M6 9V3h12v6M6 18H4a2 2 0 0 1-2-2v-5h20v5a2 2 0 0 1-2 2h-2M6 14h12v7H6z',
  select: 'M4 8V4h4M16 4h4v4M20 16v4h-4M8 20H4v-4M8 12h8',
  globe: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM3 12h18M12 3c2.5 2.5 3.8 5.5 3.8 9s-1.3 6.5-3.8 9c-2.5-2.5-3.8-5.5-3.8-9S9.5 5.5 12 3z',
  reply: 'M9 14L4 9l5-5M4 9h10a6 6 0 0 1 6 6v5',
  share: 'M12 3v12M8 7l4-4 4 4M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7',
};
